import {
  Direction,
  type LeaderboardTab,
  Metric,
  type MetricConfig,
  NumericTenantKey,
} from "./types";

export const RECYCLING_RATE_LEADERBOARD_TAB: LeaderboardTab = {
  key: Metric.RECYCLING_RATE,
  label: "homePage:leaderboardTabRecyclingRate",
};

export const GENERAL_WASTE_LEADERBOARD_TAB: LeaderboardTab = {
  key: Metric.GENERAL_WASTE,
  label: "homePage:leaderboardTabGeneralWaste",
};

export const CONTAMINATION_LEADERBOARD_TAB: LeaderboardTab = {
  key: Metric.CONTAMINATION,
  label: "homePage:leaderboardTabContamination",
};

export const SUBTITLES: Record<Metric, Record<Direction, string>> = {
  [Metric.RECYCLING_RATE]: {
    [Direction.TOP]: "homePage:leaderboardTabSubtitleRateTop",
    [Direction.BOTTOM]: "homePage:leaderboardTabSubtitleRateBottom",
  },
  [Metric.GENERAL_WASTE]: {
    [Direction.TOP]: "homePage:leaderboardTabSubtitleAmountTop",
    [Direction.BOTTOM]: "homePage:leaderboardTabSubtitleAmountBottom",
  },
  [Metric.CONTAMINATION]: {
    [Direction.TOP]: "homePage:leaderboardTabSubtitleContaminationTop",
    [Direction.BOTTOM]: "homePage:leaderboardTabSubtitleContaminationBottom",
  },
};

export const METRIC_CONFIG: Record<Metric, MetricConfig> = {
  [Metric.RECYCLING_RATE]: {
    key: NumericTenantKey.RATE,
    higherBetter: true,
    format: (t) => `${t.rate.toFixed(1)} %`,
  },
  [Metric.GENERAL_WASTE]: {
    key: NumericTenantKey.GENERAL,
    higherBetter: false,
    format: (t) => `${t.general.toLocaleString()} kg`,
  },
  [Metric.CONTAMINATION]: {
    key: NumericTenantKey.CONTAMINATION,
    higherBetter: false,
    format: (t) => `${t.contamination.toFixed(1)} %`,
  },
};
